import { useFormikContext } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { $Button, $Col, $Input, $Row } from "us.common/components";
import { AsyncInputCode } from "us.common/components/EntitySelection/Component";
import { DEFAULT_COUNTRY_CODE } from "us.common/constants";

type PostalAreaFormProps = {
  onCancel: () => void;
};

const PostalAreaForm: React.FC<PostalAreaFormProps> = (props) => {
  const { t } = useTranslation();
  const { onCancel } = props;
  const { values, errors, isSubmitting, handleSubmit, setFieldValue } =
    useFormikContext<any>();

  return (
    <>
      <$Row gutter={16} className="mb-3">
        <$Col span={12}>
          <AsyncInputCode
            name="postalCode"
            size="small"
            label={t("US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE")}
            className="mr-0"
            maxLength={20}
            countryCode={DEFAULT_COUNTRY_CODE}
            value={values.postalCode}
            disabled={values.postalCodeId !== -1}
          />
        </$Col>
        <$Col span={12}>
          <$Button
            className="mb-n2 p-0"
            onClick={() => {
              setFieldValue("step", 2);
            }}
            data-testid="munucipality-link"
            type="link"
            disabled={false}
          >
            <span className="required mr-1">*</span>
            <strong>
              {t("US.COLLECTION.COMMON:ENTITYSELECTION.MUNICIPALITYNAME")}
            </strong>
          </$Button>
          <$Input
            required
            size="small"
            name="countyName"
            value={values.countyName}
            disabled
          />
        </$Col>
      </$Row>
      <$Row gutter={16} className="mb-3">
        <$Col span={12}>
          <$Input
            required
            size="small"
            name="postalPlace"
            value={values.postalPlace}
            label={t("US.COLLECTION.COMMON:ENTITYSELECTION.POSTALAREA")}
            className="mr-0"
          />
        </$Col>
        <$Col span={12}>
          <$Input
            size="small"
            name="countyCode"
            disabled
            value={values.countyCode}
            label={t("US.COLLECTION.COMMON:ENTITYSELECTION.MUNICIPALITYCODE")}
            className="bui-label"
          />
        </$Col>
      </$Row>
      <div className="drawer-footer-fixed align-content-center justify-content-end">
        <$Button
          className="mr-2"
          type="primary"
          loading={isSubmitting}
          htmlType="submit"
          onClick={(e: any) => {
            e.preventDefault();
            handleSubmit();
          }}
          id="save-btn"
        >
          {t("US.COMMON:COMMON.SAVE")}
        </$Button>
        <$Button onClick={() => onCancel()}>
          {t("US.COMMON:COMMON.CANCEL")}
        </$Button>
      </div>
    </>
  );
};

export default PostalAreaForm;
